import { createActionTypes, createApiActions } from '../actions-util'
import { createAction } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import {
  GetUserActionResponse,
  LoginUserActionPayload,
  LoginUserActionResponse,
  ForgotPasswordActionPayload,
  ChangePasswordActionPayload,
} from './types'
import { LanguageKeys } from '../../pages/ApplicationContent/services/types'

export const loginAction = createApiActions<
  LoginUserActionPayload,
  LoginUserActionResponse,
  AxiosError
>(createActionTypes('USER/LOGIN_USER'))

export const getUserAction = createApiActions<
  void,
  GetUserActionResponse,
  AxiosError
>(createActionTypes('USER/GET_USER'))

export const logoutAction = createAction('USER/LOGOUT')

export const initAppAction = createApiActions<void, void, AxiosError>(
  createActionTypes('USER/INIT_APP'),
)

export const verifyToken = createAction<void, 'USER/VERIFY_TOKEN'>(
  'USER/VERIFY_TOKEN',
)

export const forgotPasswordAction = createAction<
  ForgotPasswordActionPayload,
  'USER/FORGOT_PASSWORD'
>('USER/FORGOT_PASSWORD')

export const changePasswordAction = createAction<
  ChangePasswordActionPayload,
  'USER/CHANGE_PASSWORD'
>('USER/CHANGE_PASSWORD')

export const changeLanguage = createAction<LanguageKeys>('CHANGE_LANGUAGE')
